import type { ModelMessage } from 'ai';

import { Transcript, TranscriptProvider } from './Transcript.tsx';
import type { AtlasMessage } from './types.ts';
import { renderTranscript } from '#plugin-chat/lib/instructions/reconciler.ts';
import type { ToolSidecarEntry } from '#plugin-chat/lib/tool/message-formatters.ts';

export type TranscriptDeps = {
  toolRegistry: Record<string, ToolSidecarEntry>;
};

/**
 * Render an `AtlasMessage[]` thread to the prose-only `ModelMessage[]`
 * transcript sent to `streamText` — one reconciler pass over the whole
 * thread, with live thread state provided through `TranscriptProvider`.
 */
export function renderThreadTranscript(messages: readonly AtlasMessage[], deps: TranscriptDeps): ModelMessage[] {
  return renderTranscript(
    <TranscriptProvider messages={messages} toolRegistry={deps.toolRegistry}>
      <Transcript messages={messages} />
    </TranscriptProvider>,
  );
}
